import { paddings } from 'core/styles';
import { zDrawers } from 'core/styles/z-index';
import styled from 'styled-components';

export const RightSideAreaDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

export const DropdownContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  z-index: ${zDrawers + 1};
  position: relative;
  &:hover {
    cursor: pointer;
  }
`;

export const DropdownDiv = styled.div`
  position: absolute;
  top: 4.6rem;
  right: 4rem;
`;

export const NotificationBellContainerDiv = styled.div`
  padding: ${paddings.smallPadding} ${paddings.smallPadding} 0 0;
`;

export const ChangelogIndicator = styled.div`
  position: absolute;
  top: ${paddings.tinyPadding};
  right: 0;
  width: ${paddings.smallPadding};
  height: ${paddings.smallPadding};
  background-color: ${({ theme }) => theme.colors.red500};
  border-radius: 50%;
`;
